import { ViewContainerRef } from '@angular/core';
var CsHeaderDirective = /** @class */ (function () {
    function CsHeaderDirective(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    return CsHeaderDirective;
}());
export { CsHeaderDirective };
